import type { FilestackIntentArgs } from '@/components/core/Filestack/filestackSecurity';

import { GET_RESOURCES_PATH } from '@/constants';

type LookAndFeelRoute = {
  name?: unknown;
  params?: Record<string, unknown>;
};

type LookAndFeelOwner = { ownerType: 'template' | 'series' | 'event'; id: string };

function routeParamToString(value: unknown): string {
  if (Array.isArray(value)) {
    return value[0] ? String(value[0]) : '';
  }
  return value ? String(value) : '';
}

// Single source of truth for who owns a look-and-feel upload. Both the signed
// intent and the storage path derive from this so they can never disagree.
function resolveLookAndFeelOwner(route: LookAndFeelRoute): LookAndFeelOwner {
  const params = route.params || {};

  const templateId = routeParamToString(params.templateId);
  if (templateId) {
    return { ownerType: 'template', id: templateId };
  }

  const seriesId = routeParamToString(params.seriesId);
  if (route.name === 'RepeatingEventLookAndFeel' && seriesId) {
    return { ownerType: 'series', id: seriesId };
  }

  return { ownerType: 'event', id: routeParamToString(params.eventId) };
}

export function resolveLookAndFeelFilestackIntent(route: LookAndFeelRoute, assetKind: string): FilestackIntentArgs {
  const owner = resolveLookAndFeelOwner(route);
  switch (owner.ownerType) {
    case 'template':
      return { intent: 'studio_template_asset', assetKind, templateId: owner.id };
    case 'series':
      return { intent: 'series_registration_asset', assetKind, seriesId: owner.id };
    default:
      return { intent: 'event_asset', assetKind, event: owner.id };
  }
}

export function resolveLookAndFeelResourcesPath(route: LookAndFeelRoute): string {
  return GET_RESOURCES_PATH(resolveLookAndFeelOwner(route).id);
}
